/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalUserAdminEventOrganizerV3 interface.
 */
export function instanceOfInternalUserAdminEventOrganizerV3(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function InternalUserAdminEventOrganizerV3FromJSON(json) {
    return InternalUserAdminEventOrganizerV3FromJSONTyped(json, false);
}
export function InternalUserAdminEventOrganizerV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
export function InternalUserAdminEventOrganizerV3ToJSON(json) {
    return InternalUserAdminEventOrganizerV3ToJSONTyped(json, false);
}
export function InternalUserAdminEventOrganizerV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
    };
}
